import { render } from "./GivingForm5.vue?vue&type=template&id=72b928bb&scoped=true"
import script from "./GivingForm5.vue?vue&type=script&lang=js"
export * from "./GivingForm5.vue?vue&type=script&lang=js"

import "./GivingForm5.vue?vue&type=style&index=0&id=72b928bb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b928bb"]])

export default __exports__